import { useEffect, useState } from "react";

import { Folder } from "@core/Folder";
import { OlgaEnvironmentsAPI } from "../../../providers/OlgaEnvironmentsAPI";
import CreateFolderDrawer from "./drawers/folders/CreateFolderDrawer";
import RemoveFolderDrawer from "./drawers/folders/RemoveFolderDrawer";

const steps = {
  CREATE_NEW_FOLDER: "CREATE_NEW_FOLDER",
  REMOVE_FOLDER: "REMOVE_FOLDER",
};

export default function FlowFoldersDrawer({
  visible,
  onClose,
  onLoadFolders,
  onLoadFlows,
}) {
  const [step, setStep] = useState(steps.CREATE_NEW_FOLDER);
  const [folderToRemove, setFolderToRemove] = useState(null);
  const [loading, setLoading] = useState(true);

  const [folders, setFolders] = useState([]);

  useEffect(() => {
    if (visible) {
      setStep(steps.CREATE_NEW_FOLDER);
      loadFolders();
    }
  }, [visible]);

  const loadFolders = async () => {
    setLoading(true);
    const environmentConfigurations =
      await OlgaEnvironmentsAPI.getConfigurations();
    const folders = environmentConfigurations.getData({})?.flow_folders || [];
    setFolders(folders.map((folder) => new Folder(folder)));
    onLoadFolders();
    setLoading(false);
  };

  return (
    <>
      <CreateFolderDrawer
        folders={folders}
        visible={visible}
        onAddFolders={() => {
          loadFolders();
          onClose();
        }}
        loading={loading}
        onUpdateFolders={(folders) => setFolders(folders)}
        onClose={onClose}
        onRemove={(folder) => {
          setFolderToRemove(folder);
          setStep(steps.REMOVE_FOLDER);
        }}
      />

      <RemoveFolderDrawer
        visible={step === steps.REMOVE_FOLDER}
        folder={folderToRemove}
        onClose={() => {
          setStep(null);
          onClose();
        }}
        onBack={() => {
          loadFolders();
          setFolderToRemove(null);
          setStep(steps.CREATE_NEW_FOLDER);
        }}
        onLoadFolders={() => {
          onLoadFolders();
          loadFolders();
        }}
        onLoadFlows={onLoadFlows}
      />
    </>
  );
}
